import * as fromProfile from '../actions/profile.action';
import {User} from '../../../users/user';

export interface ProfileState {
  users: User[];
  loading: boolean;
  loaded: boolean;
  error: string;
}

export const initialState = {
  users: null,
  loading: false,
  loaded: true,
  error: null
};

export function reducer(state = initialState, action: fromProfile.ProfileAction): ProfileState {
  switch (action.type) {
    case fromProfile.GET_POPUP: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromProfile.GET_POPUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: action.payload,
        error: null
      };
    }
    case fromProfile.GET_POPUP_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: null,
        error: action.payload
      };
    }

    case fromProfile.UPDATE_PROFILE_DETAILS_SUCCESS: {
      return {
        ...state,
        users: action.payload,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromProfile.UPDATE_PROFILE_DETAILS: {
      return {
        ...state,
        users: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromProfile.UPDATE_PROFILE_DETAILS_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }

  }
  return state;
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/profile/store/reducers/profile.reducer.ts